import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import 'boxicons/css/boxicons.min.css';
import { analytics } from './services/analyticsService';
import { initErrorTracking } from './services/errorTrackingService';
import { trackClick } from './directives/trackClick';

const app = createApp(App);
const pinia = createPinia();

// Register global click tracking directive
app.directive('track-click', trackClick);

// Initialize error tracking first (so it catches errors during initialization)
initErrorTracking(app);

// Initialize analytics
analytics.init().then(() => {
    console.log('Analytics initialized');
}).catch(err => {
    console.debug('Analytics initialization failed (non-critical):', err);
});

app.use(pinia);
app.mount('#app');
